import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { EditableTextComponent } from '../../../base/text/editable-text/editable-text.component';
import { CoordinatesSystem, ImageFormat, ScreenWidthBreakpoints } from '../../../../state-management/model/enums/screen-size.enums';
import { ImageCoordinates } from '../../../../state-management/model/interfaces/screen-size.model';
import { EditableImageComponent } from '../../../base/image/editable-image/editable-image.component';
import { FileType } from '../../../../state-management/model/enums/state.enums';
import { BaseComponent } from '../../base/base.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-base-two-column-text-image',
    imports: [
        CommonModule,
        EditableTextComponent,
        EditableImageComponent
    ],
    templateUrl: './base-two-column-text-image.component.html',
    styleUrl: './base-two-column-text-image.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseTwoColumnTextImage extends BaseComponent {
  public readonly showElement = input.required<"image" | "text" | "both">();
  
  public supportedFileTypes = [FileType.WEBP, FileType.JPEG];
  public textExpanded: boolean = false;

  override labelMap = {
    title: 'title',
    description: 'description',
    image: 'image'
  };

  override imageReference: ImageCoordinates = {
    coordinatesSystem: CoordinatesSystem.ScreenWidth,
    formatMap: {
      [ScreenWidthBreakpoints.XSmall]: ImageFormat.OneToOne,
      [ScreenWidthBreakpoints.Small]: ImageFormat.OneToOne,
      [ScreenWidthBreakpoints.Medium]: ImageFormat.OneToOne,
      [ScreenWidthBreakpoints.Large]: ImageFormat.FourToThree,
      [ScreenWidthBreakpoints.XLarge]: ImageFormat.FourToThree,
    }
  };
  
  public expandText() {
    this.textExpanded = !this.textExpanded;
  }

}